import { baseUrl } from "../../util/service";
import _get from "lodash/get";

import { getNewslettersBySearchTerm } from "@publicrelay/service/dist/nest/search";

/**
 * Redux Action (thunk) for search service
 * @param {String} accessKey
 * @param {Number} groupingId
 * @param {string} searchTerm
 * @returns {Function}
 */
export const searchNewsletters = (accessKey, groupingId, searchTerm) => (
    dispatch,
    getState
) => {
    getNewslettersBySearchTerm({
        accessKey: accessKey,
        groupingId: groupingId,
        searchTerm: searchTerm,
        baseUrl: baseUrl,
    })
        .then(response => {
            dispatch({
                type: "search/SEARCH_SUCCESS",
                payload: _get(response, "newsletterEditions", []),
            });
        })
        .catch(error => {
            dispatch({
                type: "search/SEARCH_ERROR",
                payload: error,
            });
        });
};

export const resetSearch = () => ({
    type: "search/TOGGLE_ACTIVE_STATE",
});

export const clearSearch = () => ({
    type: "search/CLEAR_SEARCH",
});

export const onChangeNewsletterSearch = searchTerm => ({
    type: "search/ONCHANGE_SEARCH",
    payload: searchTerm,
});
